import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IDesignation, IDesignationState } from './types';

const initialState: IDesignationState = {
  designation: {},
  deleteDesignation: {},
  addDesignation: {},
};

const slice = createSlice({
  name: 'designation',
  initialState,
  reducers: {
    getDesignations(state) {
      state.designation.status = RequestStatus.RUNNING;
    },
    getDesignationsSuccess(state, action: PayloadAction<IDesignationState['designation']['data']>) {
      state.designation.status = RequestStatus.SUCCESS;
      state.designation.data = action.payload;
    },
    getDesignationsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.designation.status = RequestStatus.ERROR;
      state.designation.error = action.payload;
    },
    //
    deleteDesignation(state, action: PayloadAction<{ id: number }>) {
      state.deleteDesignation.status = RequestStatus.RUNNING;
    },
    deleteDesignationSuccess(state, action: PayloadAction<IDesignation>) {
      state.deleteDesignation.status = RequestStatus.SUCCESS;
    },
    deleteDesignationFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteDesignation.status = RequestStatus.ERROR;
      state.deleteDesignation.error = action.payload;
    },
    //
    addDesignation(state, action: PayloadAction<IDesignation>) {
      state.addDesignation.status = RequestStatus.RUNNING;
    },
    addDesignationSuccess(state, action: PayloadAction<IDesignation>) {
      state.addDesignation.status = RequestStatus.SUCCESS;
      state.addDesignation.data = action.payload;
    },
    addDesignationFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addDesignation.status = RequestStatus.ERROR;
      state.addDesignation.error = action.payload;
    },
  },
});
export default slice.reducer;

export const {
  getDesignations,
  getDesignationsSuccess,
  getDesignationsFailed,
  deleteDesignation,
  deleteDesignationSuccess,
  deleteDesignationFailed,
  addDesignation,
  addDesignationSuccess,
  addDesignationFailed,
} = slice.actions;
